import { request } from './request'

/**
 * 会员接口
 * 所有需要认证的接口会自动从 localStorage.user.token 读取 token
 */
export const userApi = {
  /** 登录 */
  login(data) {
    return request('/api/user/login', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 获取用户信息 */
  getInfo() {
    return request('/api/user/index', {
      method: 'POST',
      formData: true
    })
  },

  /** 注册会员 */
  register(data) {
    return request('/api/user/register', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 退出登录 */
  logout() {
    return request('/api/user/logout', {
      method: 'POST',
      formData: true
    })
  },

  /** 修改会员个人信息 */
  updateProfile(data) {
    return request('/api/user/profile', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 新增/编辑用户地址 */
  editAddress(data) {
    return request('/api/user/editaddress', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 地址列表 */
  getAddressList() {
    return request('/api/user/addresslist', {
      method: 'POST',
      formData: true
    })
  },

  /** 地址详情 */
  getAddressInfo(data) {
    return request('/api/user/addressinfo', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 删除地址（文档中与地址详情共用 URL） */
  deleteAddress(data) {
    return request('/api/user/addressinfo', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 我的优惠券列表 */
  getCouponList(data) {
    return request('/api/user/couponlist', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 零售及小票 */
  getStoreBuyLog() {
    return request('/api/user/storebuylog', {
      method: 'POST',
      formData: true
    })
  },

  /** 发送短信验证码 */
  sendCode(data) {
    return request('/api/user/sendcode', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 发送邮件验证码 */
  sendEmail(data) {
    return request('/api/user/sendemail', {
      method: 'POST',
      formData: true,
      body: data
    })
  },

  /** 重置密码 */
  resetPwd(data) {
    return request('/api/user/resetpwd', {
      method: 'POST',
      formData: true,
      body: data
    })
  }
}
